<template>
  <main>
    <div class="inner_wrap">
      <section class="content1">
        <div class="inner">
          <div class="txt_wrap">
            <!-- <span class="first">마지막</span> -->
            <span class="sec">다시 돌아온</span>
            <span class="third"><span class="sty">할인쿠폰</span> 혜택</span>
            <span class="fourth">기간 : 25년 4월 1일부터 4월 30일까지</span>
          </div>
        </div>
      </section>
      <section class="content2">
        <div class="txt_wrap">
          <span class="first">이벤트 기간을 놓치셨나요?</span>
          <span class="sec">
            앵콜쿠폰으로
            <span class="sty">4월 한정</span> 진행합니다!
          </span>
        </div>
        <img src="@/assets/images/event/2025term1-2/content2.png" alt="" />
      </section>
      <section class="content3">
        <div class="inner">
          <div class="coupon1 coupon_box" @click="oneTouchCouponDownload">
            <div class="top">
              <span>
                캠퍼스북 4월 앵콜 <br />
                할인 쿠폰
              </span>
              <span>
                4월 <br />
                한정
              </span>
            </div>
            <div class="bottom">
              <span>10%</span>
              <i>
                <img
                  src="@/assets/images/event/2025term1-2/content3_1.png"
                  alt=""
                />
              </i>
            </div>
          </div>
          <ul class="bottom_box">
            <li class="coupon2">
              <router-link class="my_page" to="/account">
                <div class="top">
                  <span>
                    캠퍼스북 4월 앵콜 <br />
                    신규회원 가입축하
                  </span>
                </div>
                <div class="bottom">
                  <span>10%</span>
                  <span>자동 <br />발급</span>
                </div>
              </router-link>
            </li>
            <li class="coupon3">
              <router-link class="my_page" to="/account">
                <div class="top">
                  <span>
                    캠퍼스북 4월 앵콜 <br />
                    신규회원 가입축하
                  </span>
                </div>
                <div class="bottom">
                  <span>5%</span>
                  <span>자동 <br />발급</span>
                </div>
              </router-link>
            </li>
          </ul>
          <button class="receive all" @click="oneTouchCouponDownload">
            <img
              src="@/assets/images/event/2025term1-2/download_btn.png"
              alt=""
            />
          </button>
        </div>
      </section>
      <div class="caution_wrap" @click="toggleCaution(0)">
        <span class="txt" :class="{ 'active': cautionStates[0] }">
          유의사항
        </span>
        <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-show="cautionStates[0]" class="slide_list">
            <div class="cau_wrap1">
              <ul>
                <li>
                  ※ 해당 할인쿠폰은 캠퍼스북 회원만 발급이 가능합니다.
                </li>
                <li>
                  ※ 해당 할인쿠폰의 사용기한은 앵콜이벤트로 인해 4월 30일 오후
                  11시 59분까지이며, 기한 내 미사용시 자동적으로 소멸됩니다.
                </li>
                <li>
                  ※ 해당 이벤트로 발급된 할인쿠폰은 [내정보>쿠폰함]에서 확인이
                  가능합니다.
                </li>
                <li>
                  ※ 해당 할인쿠폰은 일부 할인 불가 도서를 제외한 전 상품에 적용
                  가능합니다.
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <Transition name="modal-fade">
      <Modal v-if="showCouponModal" @close="toggleCouponModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <p>{{ couponMessage }}</p>
                  <!-- <p>할인 쿠폰이 발급되었습니다.</p> -->
                  <!-- <p>주문시 사용가능합니다.</p> -->
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
                <button class="box_btn" @click="navigateToCoupon">
                  <span class="an_t">
                    쿠폰함으로 이동
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal v-if="showCouponErrorModal" @close="toggleCouponErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <!-- <p>쿠폰 수령 횟수를 초과했습니다</p> -->
                  <!-- <p>쿠폰은 3회까지 다운로드 가능합니다</p> -->
                  <p>{{ couponErrorMessage }}</p>
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Transition>
  </main>
</template>
<script>
import { ONE_TOUCH_COUPON } from '@/store/types'
import { mapGetters } from 'vuex'
export default {
  name: 'term2025-1-2',
  data() {
    return {
      cautionStates: [false, false],
      couponMessage: '',
      couponErrorMessage: '',
      showCouponModal: false,
      showCouponErrorModal: false,
      isCopied: false,
      showTooltip: false,
      tooltipTimeout: null
    }
  },
  computed: {
    ...mapGetters(['getCurrentUser'])
  },
  methods: {
    toggleCaution(index) {
      this.$set(this.cautionStates, index, !this.cautionStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      // el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      // el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    scrollToSection(targetSelector) {
      const targetElement = document.querySelector(targetSelector)

      if (targetElement) {
        // 요소의 위치와 계산된 스타일 가져오기
        const elementRect = targetElement.getBoundingClientRect()
        const computedStyle = window.getComputedStyle(targetElement)

        // 패딩 및 마진 계산
        const marginTop = parseInt(computedStyle.marginTop)
        const paddingTop = parseInt(computedStyle.paddingTop)

        // 요소의 절대 위치 계산
        const absoluteElementTop = elementRect.top + window.pageYOffset

        // 최종 오프셋 계산 (패딩 및 마진 포함)
        let finalOffset = absoluteElementTop - marginTop - paddingTop

        if (window.innerWidth <= 1022) {
          finalOffset -= 60 // 60px 추가 오프셋
        }
        if (window.innerWidth <= 768) {
          finalOffset -= 12
        }
        if (window.innerWidth <= 480) {
          finalOffset -= 12
        }
        window.scrollTo({
          top: finalOffset,
          behavior: 'smooth'
        })
      }
    },
    toggleCouponModal() {
      this.showCouponModal = !this.showCouponModal
    },
    toggleCouponErrorModal() {
      this.showCouponErrorModal = !this.showCouponErrorModal
    },
    async oneTouchCouponDownload() {
      if (!this.getCurrentUser) {
        if (confirm('로그인이 필요합니다. 로그인 하시겠습니까?')) {
          this.$router.push({ name: 'login' })
          return
        } else {
          return
        }
      }
      // 이 아래 쿠폰 받기 구현.
      // 클릭하면 받으시겠습니까? 질문 없이 즉시 받기
      // 받고나서 확인 + 쿠폰함 이동 버튼 - LIKE 책을 장바구니에 넣었을 때처럼

      // 쿠폰 수령 후 알림창 띄워주는 부분.
      // 알림창은 장바구니 부분을 참고하여 만들어 짐.
      let resp = await this.$store.dispatch(ONE_TOUCH_COUPON)
      let result = resp.data.result
      switch (result.state) {
        case 'success':
          this.couponMessage = result.modal
          this.showCouponModal = true
          break
        case 'fail':
          this.couponErrorMessage = result.modal
          this.showCouponErrorModal = true
          break
        case 'error':
          alert(result.message)
          break
        default:
          console.log('out of case')
      }
    },
    navigateToCoupon() {
      this.$router.push({ name: 'discount' })
    },
    copyToClipboard() {
      // 현재 URL 가져오기
      const currentUrl = window.location.href

      // 복사를 위한 임시 textarea 요소 생성
      const textarea = document.createElement('textarea')
      textarea.value = currentUrl
      textarea.style.position = 'fixed' // 하단으로 스크롤 방지
      document.body.appendChild(textarea)
      textarea.select()

      try {
        // 복사 명령 실행
        const successful = document.execCommand('copy')
        if (successful) {
          this.showCopiedFeedback()
        } else {
          console.error('복사 명령이 실패했습니다')
        }
      } catch (err) {
        console.error('복사 작업 중 오류 발생:', err)
      }

      // 정리 작업
      document.body.removeChild(textarea)
    },
    showCopiedFeedback() {
      // 시각적 피드백을 위한 상태 설정
      this.isCopied = true
      this.showTooltip = true

      // 기존 타임아웃 제거
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }

      // 일정 시간 후 상태 초기화
      this.tooltipTimeout = setTimeout(() => {
        this.isCopied = false
        this.showTooltip = false
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
section {
  position: relative;
  width: 100%;
}
.inner_wrap {
  max-width: 1120px;
  margin: 0 auto;
  background: #042c66;
  text-align: center;
}
.inner {
  max-width: 790px;
  margin: 0 auto;
}
.caution_wrap {
  background-color: #565656;
  user-select: none;
  cursor: pointer;
  &.user_cause {
    padding: 0;
  }
  .txt {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 20px;
    padding: 70px 0;
    background: #000;
    font-family: 'pretendard-light';
    font-size: 37px;
    line-height: 37px;
    color: #989898;
    &::after {
      content: '';
      transform: rotate(-45deg);
      transform-origin: center;
      width: 20px;
      height: 20px;
      border-top: 3px solid #989898;
      border-right: 3px solid #989898;
    }
    &.active {
      &::after {
        transform: translateY(-50%) rotate(135deg);
      }
    }
  }
  .slide_list {
    // width: 600px;
    padding: 64px 195px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    list-style-type: disc;
    font-size: 23px;
    color: #989898;
    .point_save {
      margin-bottom: 10px;
    }
    .cau_wrap1,
    .cau_wrap2,
    .cau_wrap3 {
      line-height: 43px;
      ul {
        li {
          line-height: 35px;
        }
      }
      h2 {
        font-size: 45px;
        margin: 50px 0 40px;
      }
    }
  }
}
// content1
.content1 {
  .txt_wrap {
    padding-top: 130px;
    span {
      display: block;
      margin-bottom: 20px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      letter-spacing: 1px;
      &.first {
        font-size: 80px;
        line-height: 80px;
        color: #fff;
      }
      &.sec {
        font-size: 84px;
        line-height: 84px;
        color: #ffea61;
      }
      &.third {
        position: relative;
        margin-bottom: 40px;
        font-size: 100px;
        line-height: 100px;
        color: #fff;
        &::before {
          content: '';
          position: absolute;
          top: -77%;
          left: 5%;
          background: url('../../../assets/images/event/2025term1-2/content1_back1.png')
            no-repeat;
          width: 111px;
          height: 106px;
        }
        &::after {
          content: '';
          position: absolute;
          top: -38px;
          right: 20px;
          background: url('../../../assets/images/event/2025term1-2/content1_back2.png')
            no-repeat;
          width: 121px;
          height: 129px;
        }
        .sty {
          display: inline;
          color: #bd57ff;
        }
      }
      &.fourth {
        font-family: 'pretendard-light';
        font-weight: 400;
        margin-bottom: 50px;
        font-size: 33px;
        line-height: 33px;
        color: #fff;
      }
    }
  }
}
// content2
.content2 {
  margin-bottom: 90px;
  img {
    width: 700px;
  }
  .txt_wrap {
    margin-bottom: 65px;
    span {
      display: block;
      font-size: 32px;
      line-height: 40px;
      color: #fff;
      &.first {
      }
      &.sec {
        position: relative;
        display: inline-block;
        &::after {
          content: '';
          position: absolute;
          bottom: 0px;
          left: 0;
          width: 100%;
          height: 16px;
          background-color: #ffea61;
          opacity: 0.1;
        }
        .sty {
          display: inline;
          color: #ffea61;
        }
      }
    }
  }
}
// content3
.content3 {
  margin-bottom: 70px;
  background: url('../../../assets/images/event/2025term1-2/content3_back.png')
    no-repeat center top;
  background-size: 75%;
  // &::after {
  //   content: '';
  //   display: block;
  //   background: url('../../../assets/images/event/2025term1-2/content3_back.png')
  //     no-repeat center center;
  //   background-size: cover;
  //   width: 100%;
  //   height: 100%;
  // }
  .coupon_box {
    position: relative;
    max-width: 540px;
    margin: 0 auto 75px;
    padding: 25px 15px 25px 35px;
    background: linear-gradient(to right, #bfc9d8, #072e67);
    border: 1px solid #fff;
    cursor: pointer;
    span {
      display: block;
    }
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -60px;
      width: 51px;
      height: 51px;
      background: url('../../../assets/images/event/2025term1-2/content3_2.png')
        no-repeat;
      pointer-events: none;
    }
  }
  .coupon1 {
    i {
      display: block;
      width: 79px;
      height: 79px;
    }
  }
  .bottom_box {
    display: flex;
    justify-content: center;
    gap: 50px;
    margin-bottom: 70px;
    li {
      flex: 0.41;
      background: linear-gradient(to right, #bfc9d8, #072e67);
      border: 1px solid #fff;
      a {
        display: block;
        padding: 20px 20px;
      }
      .top {
        span {
          display: block;
          &:nth-child(1) {
            font-family: 'pretendard-medium';
            line-height: 23px;
            font-size: 20px;
            text-align: left;
          }
        }
      }
      .bottom {
        span {
          &:nth-child(1) {
            font-family: 'pretendard-medium';
            line-height: 58px;
            font-size: 58px;
            text-align: left;
          }
          &:nth-child(2) {
            width: 71px;
            height: 71px;
            margin-right: 3px;
            font-size: 19px;
            line-height: 22px;
            font-family: 'pretendard-medium';
            padding-top: 12px;
            font-weight: 600;
            text-align: center;
            background-color: #ffea61;
            border-radius: 100%;
          }
        }
      }
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    span:nth-child(1) {
      font-family: 'pretendard-medium';
      line-height: 29px;
      font-size: 22px;
      text-align: left;
    }
    span:nth-child(2) {
      width: 71px;
      height: 71px;
      margin-right: 3px;
      font-size: 19px;
      line-height: 22px;
      font-family: 'pretendard-medium';
      padding-top: 12px;
      font-weight: 600;
      text-align: center;
      background-color: #ffea61;
      border-radius: 100%;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span:nth-child(1) {
      font-family: 'pretendard-medium';
      font-weight: 600;
      line-height: 71px;
      font-size: 71px;
      text-align: left;
    }
  }
}
@media (max-width: 1024px) {
  .content1 .txt_wrap {
    padding-top: 225px;
  }
}
@media (max-width: 960px) {
  .caution_wrap .slide_list {
    padding: 64px 100px;
  }
}
@media (max-width: 768px) {
  .content3 .coupon_box {
    max-width: 480px;
  }
  .content2 img {
    width: 480px;
  }
}
@media (max-width: 480px) {
  .content1 .txt_wrap span.third::before {
    top: -79%;
    left: -7%;
    background-size: 68%;
  }
  .content1 .txt_wrap span.third::after {
    top: -28px;
    right: -76px;
    background-size: 68%;
  }
  .content1 .txt_wrap {
    padding-top: 60px;
  }
  .content1 .txt_wrap span {
    margin-bottom: 10px;
  }
  .content1 .txt_wrap span.first {
    font-size: 44px;
    line-height: 44px;
  }
  .content1 .txt_wrap span.sec {
    font-size: 48px;
    line-height: 48px;
  }
  .content1 .txt_wrap span.third {
    margin-bottom: 27px;
    font-size: 59px;
    line-height: 59px;
  }
  .content1 .txt_wrap span.fourth {
    font-size: 20px;
    line-height: 20px;
  }
  .content2 {
    margin-bottom: 70px;
  }
  .content2 img {
    max-width: 360px;
  }
  .content2 .txt_wrap {
    margin-bottom: 36px;
  }
  .content2 .txt_wrap span {
    font-size: 23px;
    line-height: 28px;
  }
  .content3 {
    background-size: 100%;
    padding: 0 20px;
  }
  .content3 .bottom_box {
    flex-direction: column;
  }
  .content3 .bottom_box li a {
    padding: 20px 14px 20px 20px;
  }
  .content3 .coupon_box {
    max-width: 360px;
    padding: 20px 15px 20px 20px;
  }
  .content3 .top span:nth-child(1) {
    line-height: 25px;
    font-size: 19px;
  }
  .content3 .top span:nth-child(2) {
    width: 61px;
    height: 61px;
    padding-top: 13px;
    font-size: 15px;
    line-height: 17px;
  }
  .content3 .bottom span:nth-child(1) {
    line-height: 52px;
    font-size: 52px;
  }
  .content3 .coupon1 i {
    width: 69px;
    height: 69px;
  }
  .content3 .bottom_box li .bottom span:nth-child(2) {
    width: 61px;
    height: 61px;
    padding-top: 13px;
    font-size: 15px;
    line-height: 17px;
  }
  .content3 .bottom_box li .top span:nth-child(1) {
    line-height: 22px;
    font-size: 18px;
  }
  .content3 .bottom_box li .bottom span:nth-child(1) {
    line-height: 51px;
    font-size: 51px;
  }
  .caution_wrap .txt {
    gap: 12px;
    padding: 40px 0;
    font-size: 24px;
    line-height: 24px;
  }
  .caution_wrap .txt::after {
    width: 13px;
    height: 13px;
  }
  .caution_wrap .slide_list {
    font-size: 15px;
    padding: 25px 25px;
    .cau_wrap1,
    .cau_wrap2,
    .cau_wrap3 {
      ul {
        li {
          line-height: 26px;
        }
      }
    }
  }
}
</style>
